import { render, staticRenderFns } from "./planBuy.vue?vue&type=template&id=844a1382&scoped=true"
import script from "./planBuy.vue?vue&type=script&lang=js"
export * from "./planBuy.vue?vue&type=script&lang=js"
import style0 from "./planBuy.vue?vue&type=style&index=0&id=844a1382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844a1382",
  null
  
)

export default component.exports